import siteInfoPopupComponent from './siteInfoPopup.component';

const siteInfoPopupModule = angular.module('app.components.clinicalData.site.siteInfoPopup', [])
	.component('siteInfoPopup', siteInfoPopupComponent)
	.name;

export default siteInfoPopupModule;
